export async function fetchShopList(
  type?: string,
  sort?: string,
  keyword?: string,
  take?: number,
  skip?: number,
) {
  let url = `${process.env.NEXT_PUBLIC_API_URL}/api/shops/list`;
  if (type || keyword || take || skip || sort) {
    url += '?';
  }
  if (type) {
    url += `&type=${type}`;
  }
  if (keyword) {
    url += `&keyword=${keyword}`;
  }
  if (take && skip) {
    url += `&take=${take}&skip=${skip}`;
  }
  if (sort) {
    url += `&sort=${sort}`;
  }
  const res = await fetch(url, {});
  return await res.json();
}
